module.exports = __webpack_public_path__ + "img/logo.176ae9de.svg";